import ArticleLayout from '@/components/feature/ArticleLayout';
import { superbuyArticleContent } from '@/mocks/seoContent';

export default function SuperbuyArticle() {
  return (
    <ArticleLayout
      article={superbuyArticleContent}
      heroImage="https://readdy.ai/api/search-image?query=Global%20commerce%20concept%20with%20world%20map%20textures%20and%20shipping%20package%20elements%20on%20clean%20minimal%20surface%2C%20warm%20neutral%20palette%20with%20sage%20green%20accents%2C%20soft%20natural%20lighting%2C%20editorial%20style%2C%20professional%20composition%2C%20international%20trade%20aesthetic&width=1200&height=600&seq=article-superbuy-hero-v3&orientation=landscape"
      heroImageAlt="Superbuy Spreadsheet international buyer's resource guide"
      heroImageTitle="Superbuy Spreadsheet 2026 Complete Guide"
      tag="International Guide"
      relatedArticles={[
        { title: "Hipobuy Spreadsheet Guide", slug: "hipobuy-spreadsheet-guide" },
        { title: "Kakobuy Spreadsheet Guide", slug: "kakobuy-spreadsheet" },
        { title: "CSSBuy Spreadsheet Guide", slug: "cssbuy-spreadsheet" },
        { title: "Oopbuy Spreadsheet Guide", slug: "oopbuy-spreadsheet" },
      ]}
    />
  );
}